import { DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { invoiceCfeRoutePage } from '../routePageConfig';
import InfoiceCFeGeneralForm from '@/components/Fiscal/Invoice/InvoiceCFe/InfoiceCFeGeneralForm';
import { useEffect } from 'react';
import { Form } from 'antd';
import InvoiceCFEHeader from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEHeader';
import { useInvoiceCFEFormContext } from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEFormProvider';
import moment from 'moment';
import InvoiceCFEFooter from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEFooter';
import { getActiveTabPageTaxCoupon } from '@/components/Fiscal/Invoice/InvoiceCFe/getActiveTabPageTaxCoupon';

const InvoiceCFeGeneralDataPage: React.FC<PageProps> = ({ route }) => {
  const { formsInstance, taxCoupon } = useInvoiceCFEFormContext();

  const [form] = Form.useForm(formsInstance.general);

  useEffect(() => {
    if (taxCoupon && !formsInstance.general) {
      form.setFieldsValue({
        companyId: taxCoupon.companyId,
        createdAt: moment(taxCoupon.createdAt),
        id: taxCoupon.id,
        status: taxCoupon.status,
        customer: taxCoupon.recipient,
        sefazReferenceCode: taxCoupon.sefazReferenceCode,
      });
    }
  }, [taxCoupon]);

  return (
    <DefaultRouteTabs
      route={invoiceCfeRoutePage(route)}
      permissions={route.permissions}
      {...getActiveTabPageTaxCoupon()}
    >
      <Helmet title="Dados CF-e" />

      <InvoiceCFEHeader />

      <InfoiceCFeGeneralForm form={form} />

      <InvoiceCFEFooter />
    </DefaultRouteTabs>
  );
};

export default InvoiceCFeGeneralDataPage;
